import React from 'react';
import SEO from '../SEO/SEO';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import NewsletterSignup from '../NewsletterSignup/NewsletterSignup';
import '../Styles/reset.css';
import '../Styles/utils.css';
import '../Styles/layout.css';

function HealthDisclaimer() {
    return (
        <div>
            <SEO
                title="Health & Wellness Disclaimer - Smart Life Choice"
                description="Important health and wellness disclaimer for Smart Life Choice. Understand that our content is for educational purposes and should not replace professional medical advice."
                url="/health-disclaimer"
                keywords="health disclaimer, medical disclaimer, wellness disclaimer, fitness disclaimer, educational content"
            />
            <Header />

            <main className="main">
                <div className="container">
                    <section className="policy-section" style={{
                        maxWidth: '900px',
                        margin: '0 auto',
                        padding: '2rem 1rem'
                    }}>
                        <h1 style={{
                            fontSize: '2.5rem',
                            fontWeight: '700',
                            marginBottom: '1rem',
                            color: 'var(--color-primary)'
                        }}>Health & Wellness Disclaimer</h1>

                        <div style={{
                            fontSize: '0.95rem',
                            color: 'var(--color-gray-600)',
                            marginBottom: '2rem',
                            paddingBottom: '1rem',
                            borderBottom: '2px solid var(--color-gray-200)'
                        }}>
                            <p><strong>Effective Date:</strong> 10 November 2025</p>
                        </div>

                        <div style={{
                            lineHeight: '1.8',
                            fontSize: '1.05rem',
                            color: 'var(--color-gray-800)'
                        }}>
                            <div style={{
                                backgroundColor: '#fff3cd',
                                border: '2px solid #ffc107',
                                borderRadius: '8px',
                                padding: '1.5rem',
                                marginBottom: '2rem'
                            }}>
                                <p style={{ marginBottom: '1rem', fontWeight: '600', color: '#856404' }}>
                                    IMPORTANT NOTICE
                                </p>
                                <p style={{ marginBottom: '0', color: '#856404' }}>
                                    The information provided on Smart Life Choice (smartlifechoice.co.uk) is for general
                                    educational purposes only and should not be considered medical advice.
                                </p>
                            </div>

                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>Always Consult a Professional</h2>
                            <p style={{ marginBottom: '1rem' }}>
                                Always:
                            </p>
                            <ul style={{
                                marginLeft: '2rem',
                                marginBottom: '1.5rem',
                                listStyle: 'disc'
                            }}>
                                <li style={{ marginBottom: '0.75rem' }}>
                                    Consult your doctor or qualified health professional before making changes to your diet,
                                    exercise, or wellness routine.
                                </li>
                                <li style={{ marginBottom: '0.75rem' }}>
                                    Never disregard medical advice because of something you read on this website.
                                </li>
                            </ul>

                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>No Medical Advice</h2>
                            <p style={{ marginBottom: '1.5rem' }}>
                                While we strive for accuracy, we do not guarantee that all information is complete, up to date,
                                or applicable to every individual. We are not licensed medical professionals, and the content
                                on this site should not be used as a substitute for professional medical advice, diagnosis, or treatment.
                            </p>

                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>Limitation of Liability</h2>
                            <p style={{ marginBottom: '1.5rem' }}>
                                By using this site, you agree that Smart Life Choice and its authors are not responsible for
                                any outcomes arising from reliance on the content published here. Any actions you take based on
                                information from this website are at your own risk.
                            </p>

                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>Individual Results May Vary</h2>
                            <p style={{ marginBottom: '1.5rem' }}>
                                Results from following any health, fitness, or wellness advice may vary from person to person.
                                What works for one individual may not work for another due to differences in genetics, lifestyle,
                                medical conditions, and other factors.
                            </p>

                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>Emergency Medical Situations</h2>
                            <p style={{ marginBottom: '1.5rem' }}>
                                If you are experiencing a medical emergency, please call emergency services immediately.
                                Do not rely on information from this website for urgent medical situations.
                            </p>

                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>Contact Us</h2>
                            <p style={{ marginBottom: '1.5rem' }}>
                                If you have questions about this disclaimer, please contact us at:{' '}
                                <a href="mailto:smartlifechoiceuk@gmail.com" style={{
                                    color: 'var(--color-primary)',
                                    textDecoration: 'underline'
                                }}>smartlifechoiceuk@gmail.com </a>
                            </p>
                        </div>
                    </section>
                </div>

                <NewsletterSignup />
            </main>

            <Footer />
        </div>
    );
}

export default HealthDisclaimer;
